import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import axios from 'axios';
import root from 'window-or-global';

type SetInterval = ReturnType<typeof setInterval>;

export const useSendAnalytics = () => {
  const router = useRouter();
  const timeRef = useRef(0);
  const asPathRef = useRef(router.asPath);
  const [intervalId, setIntervalId] = useState<SetInterval>();

  const sendTimeOnPage = () => {
    const payload = JSON.stringify({
      pathToPage: asPathRef.current,
      timeOnPageMs: timeRef.current,
    });

    if (root?.navigator?.sendBeacon) {
      root.navigator.sendBeacon('/docs/api/analytics/time', payload);
    } else {
      axios.post('/docs/api/analytics/time', payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }
  };

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      // Send time on page after browser tab is switched, closed .etc
      sendTimeOnPage();
    }

    // Clear time on page if user switched browser tab or browser window
    timeRef.current = 0;
  };

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(intervalId as SetInterval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    timeRef.current = 0;
    asPathRef.current = router.asPath;

    // Send pathToPage after document page is opened
    axios
      .post('/docs/api/analytics', {
        pathToPage: asPathRef.current,
      })
      .catch((error) => {
        console.error(error.toJSON());
      });

    setIntervalId(
      setInterval(() => {
        timeRef.current += 1000;
      }, 1000)
    );

    return () => {
      // Send time on page after route is changed
      sendTimeOnPage();
      // Clear on page time interval after route is changed
      clearInterval(intervalId as SetInterval);
    };
  }, [router.asPath]);
};
